<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="7em" class="baseInfoForm">
            <el-form-item label="竞赛类型" prop="type">
                <el-radio v-model="form.type" label="泰迪杯" border></el-radio>
                <el-radio v-model="form.type" label="其他" border></el-radio>
            </el-form-item>
            <el-form-item label="竞赛名称" prop="name">
                <div v-if="form.type=='泰迪杯'">
                    <el-select
                            v-model="form.name"
                            filterable
                            default-first-option
                            maxlength="30"
                            placeholder="请选择竞赛名称">
                        <el-option
                                v-for="item in competitionNameOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div v-else>
                    <el-input v-model="form.name" maxlength="30" placeholder="请输入竞赛名称"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="竞赛时间" prop="startTime">
                <el-date-picker
                        v-model="form.dateRange"
                        type="daterange"
                        @change="handleDateRange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        value-format="yyyy-MM-dd"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="获奖等级" prop="level">
                <div v-if="form.type=='泰迪杯'">
                    <el-select
                            v-model="form.level"
                            filterable
                            default-first-option
                            maxlength="30"
                            placeholder="请选择获奖等级">
                        <el-option
                                v-for="item in levelOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div v-else>
                    <el-input v-model="form.level" maxlength="30" placeholder="请输入获奖等级"></el-input>
                </div>
            </el-form-item>

            <el-form-item label="获奖证书">
                <div v-if="form.certificate" class="upImg" style="height:200px">
                    <img :src="imageLocation(form.certificate)"/>
                    <el-button type="text" icon="el-icon-delete" @click="deleteCertificate"></el-button>
                </div>
                <div class="uploaderDiv">
                    <uploader ref="uploader" :options="uploaderOptions" @file-added="fileAdded"
                              @file-success="handleUploadSuccess">
                        <uploader-unsupport></uploader-unsupport>
                        <div class="uploader-files">
                            <slot :files="files">
                                <ul>
                                    <li v-for="(file,i) in files" :key="file.id">
                                        <div class="upImg" style="height:200px">
                                            <img :src="previewPictures(file)">
                                            <el-button type="text" icon="el-icon-delete" @click="deleteFile(i)"></el-button>
                                        </div>
                                        {{file.name}}
                                    </li>
                                </ul>
                            </slot>
                        </div>
                        <uploader-btn :attrs="attrs" class="el-button el-button--default is-plain"
                                      v-if="files.length==0 && !form.certificate">
                            <i class="el-icon-circle-plus-outline"></i>上传附件
                        </uploader-btn>
                    </uploader>
                </div>
                <input type="hidden" v-model="form.attachment">
                <div class="uploadTxt">支持上传一张JPG、JPEG、PNG格式图片，文件不可大于10MB</div>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="updateCompetitionExperience()" v-if="editStatus.status==true">更新保存
                </el-button>
                <el-button type="primary" @click="saveCompetitionExperience()" v-else>保存</el-button>
                <el-popconfirm title="确认取消编辑？"
                               @confirm="cancel()"
                               placement="top-start"
                               icon="el-icon-info"
                               icon-color="red"
                               class="ml10">
                    <el-button slot="reference">取消</el-button>
                </el-popconfirm>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {saveCompetitionExperience, updateCompetitionExperience} from '@/api/resume';
    import {getTreeListByDictType} from '@/api/dict';
    import {mergeFile} from '@/api/file';

    export default {
        name: 'competitionExperienceForm',
        props: ['form', 'resumeId', 'editStatus'],
        data() {
            return {
                rules: {
                    type: [
                        {required: true, message: '请选择竞赛类型'},
                    ],
                    name: [
                        {required: true, message: '请输入竞赛名称'},
                        {max: 30, message: '字符长度不超过30'},
                        {pattern: /^[^ ]+$/, message: '支持输入中英文、数字、特殊符号等'}
                    ],
                    level: [
                        {required: true, message: '请输入获奖等级'},
                        {max: 30, message: '字符长度不超过30'},
                    ],
                    startTime: [
                        {required: true, message: '请选择竞赛时间'},
                    ]
                },
                // 竞赛名称选项参数
                competitionNameOptions: [],
                // 获奖等级选项参数
                levelOptions: [],
                // uploader组件文件上传参数
                uploaderOptions: {
                    target: '/api/file/chunk',
                    chunkSize: '1048576',
                    testChunks: true,
                    checkChunkUploadedByResponse: this.checkChunkUploadedByResponse,
                },
                // uploader组件上传证书附件文件类型限制
                attrs: {
                    accept: '.jpg, .jpeg, .png'
                },
                // uploader组件文件上传校验
                validateFile: {
                    accept: '.jpg, .jpeg, .png',
                    limit: 1,
                    totalSize: 10,
                    tip: '可上传1个文件，总大小不超过10MB'
                },
                // 附件文件Id
                attachmentFileId: '',
                // 附件文件上传对象
                files: [],
                // 竞赛名称输入类型：选择框/输入框
                name: true,
            }
        },
        created() {
            this.loadDictData();
        },
        watch: {
            // 监听证书类型实现证书名称选择项相对应的改变
            'form.type'(newValue, oldValue) {
                this.form.name = null;
                this.form.level = null;
            }
        },
        computed: {
            imageLocation() {
                return function (file) {
                    let imagePath = encodeURI(file);
                    return `/files?imagePath=${imagePath}`;
                }
            },
        },
        methods: {
            handleDateRange(val) {
                if (val && val.length == 2) {
                    this.form.startTime = val[0];
                    this.form.endTime = val[1];
                } else {
                    this.form.startTime = '';
                    this.form.endTime = '';
                }
                console.log(val);
                console.log(this.form);
            },
            /** 获取字典数据 */
            loadDictData() {
                getTreeListByDictType("competition_name").then(response => {
                    this.competitionNameOptions = response.data;
                });
                getTreeListByDictType("award_level").then(response => {
                    this.levelOptions = response.data;
                });
            },
            deleteCertificate() {
                if (this.form.certificate) {
                    this.form.certificate = '';
                }
            },
            // 保存简历竞赛经历
            saveCompetitionExperience() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        saveCompetitionExperience(this.form).then(res => {
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(() => {
                            this.$message.error("简历竞赛经历失败");
                        });
                    }
                })
            },
            // 保存简历竞赛经历
            updateCompetitionExperience() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.form.resumeId = this.resumeId;
//                        if (this.form.fileId==null||this.form.fileId==undefined||this.form.fileId==''){
//                            this.$message.error("请上传附件");
//                        }
                        updateCompetitionExperience(this.form).then(res => {
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(() => {
                            this.$message.error("简历竞赛经历保存失败");
                        });
                    }
                })
            },
            // 简历竞赛经历表单取消编辑状态
            cancel() {
                this.editStatus.id = 0;
                this.editStatus.status = false;
                this.$emit('editStatus', this.editStatus);
                this.$store.commit('changeResumeEditStatus', false);
                this.$store.commit('changeCompetitionExperienceEditStatus', false);
            },
            /** 预览附件照片*/
            previewPictures(file) {
                return window.URL.createObjectURL(file.file);
            },
            deleteFile(i) {
                this.files.splice(i, 1);
            },
            validateFilename(filename) {
                return /^[\u4e00-\u9fa5a-zA-Z0-9-_.]{1,20}$/.test(filename);
            },
            fileAdded(file) {
                let time = new Date().getTime();
                file.name = time + file.name.substring(file.name.indexOf("."));
                file.uniqueIdentifier = time;
                const uploader = this.$refs.uploader.uploader;
                const limit = this.validateFile.limit;
                const maxSize = 1024 * 1024 * this.validateFile.totalSize;
                const accept = this.validateFile.accept;

                const already = uploader.files.find(x => x.name === file.name);
                if (already) {
                    file.ignored = true;
                    this.$message.error('请不要重复上传相同文件');
                    file.cancel()
                    return;
                }
                if (accept.indexOf(file.name.substring(file.name.lastIndexOf('.'))) === -1) {
                    file.ignored = true;
                    this.$message.error(`文件格式不符合要求，请上传${accept}格式文件`);
                    return;
                }
                if (uploader.files.length >= limit) {
                    file.ignored = true;
                    this.$message.error(`上传的文件总数不能大于${limit}`);
                    return;
                }
                if (file.size > maxSize) {
                    file.ignored = true;
                    this.$message.error(`文件大小不能超过${this.validateFile.totalSize}MB`);
                    return;
                }
            },
            /** 分块文件上传*/
            checkChunkUploadedByResponse(chunk, message) {
                let res = JSON.parse(message);
                if (Array.isArray(res.data)) {
                    let chunkNumbers = res.data;
                    return (chunkNumbers || []).indexOf(chunk.offset + 1) >= 0;
                } else {
                    if (null === res.data) {
                        return false;
                    } else {
                        chunk.file.itemId = res.data;
                        return true;
                    }
                }
            },
            /** 分块文件上传完毕，合并分块文件，返回文件id*/
            async handleUploadSuccess(rootFile, file, message, chunk) {
                let res = JSON.parse(message);
                if (res.data && res.data === true) {
                    console.log('分块上传完成，开始合并...')
                    mergeFile(file).then((res) => {
                        console.log("文件合并完成");
                        this.form.fileId = res.data.fileId;
                        this.files = this.$refs.uploader.files;
                    }).catch(() => {

                    })
                }
            },
        }
    }
</script>
